import { useContext } from 'react';

import BeautyCampaignFormStepOne from './components/beautyCampaignFormStepOne/beautyCampaignFormStepOne';
import FashionCampaignFormStepOne from './components/fashionCampaignFormStepOne/fashionCampaignFormStepOne';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';
import { CampaignFormStepOneContextProvider } from './campaignFormStepOne.context';

const CampaignFormStepOne = () => {
  const { brand } = useContext(CampaignFormContext);

  return (
    <CampaignFormStepOneContextProvider>
      <div className="mt-[80px]">
        <div className="flex flex-col gap-16">
          {brand.isCategoryBeauty ? (
            <BeautyCampaignFormStepOne />
          ) : (
            <FashionCampaignFormStepOne />
          )}
        </div>
      </div>
    </CampaignFormStepOneContextProvider>
  );
};

export default CampaignFormStepOne;
